var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHpByg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.121)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.906 -6.442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.446,103.859a6.964,6.964,0,0,1-3.723,6.182l-55.5,31.19a6.972,6.972,0,0,1-8.008,0l-55.5-31.19A6.964,6.964,0,0,1,3,103.859V40.636a6.964,6.964,0,0,1,3.723-6.182l55.5-31.19a6.972,6.972,0,0,1,8.008,0l55.5,31.19a6.964,6.964,0,0,1,3.723,6.182v63.223M66.223,17.1,24.355,40.636,66.223,64.169l41.868-23.533L66.223,17.1M17.05,99.715,59.2,123.458V76.322L17.05,52.649V99.715m98.347,0V52.649L73.248,76.322v47.136Z",
    transform: "translate(62.664 101.806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.446,103.859a6.964,6.964,0,0,1-3.723,6.182l-55.5,31.19a6.972,6.972,0,0,1-8.008,0l-55.5-31.19A6.964,6.964,0,0,1,3,103.859V40.636a6.964,6.964,0,0,1,3.723-6.182l55.5-31.19a6.972,6.972,0,0,1,8.008,0l55.5,31.19a6.964,6.964,0,0,1,3.723,6.182v63.223M66.223,17.1,24.355,40.636,66.223,64.169l41.868-23.533L66.223,17.1M17.05,99.715,59.2,123.458V76.322L17.05,52.649V99.715m98.347,0V52.649L73.248,76.322v47.136Z",
    transform: "translate(6.906 6.563)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.446,103.859a6.964,6.964,0,0,1-3.723,6.182l-55.5,31.19a6.972,6.972,0,0,1-8.008,0l-55.5-31.19A6.964,6.964,0,0,1,3,103.859V40.636a6.964,6.964,0,0,1,3.723-6.182l55.5-31.19a6.972,6.972,0,0,1,8.008,0l55.5,31.19a6.964,6.964,0,0,1,3.723,6.182v63.223M66.223,17.1,24.355,40.636,66.223,64.169l41.868-23.533L66.223,17.1M17.05,99.715,59.2,123.458V76.322L17.05,52.649V99.715m98.347,0V52.649L73.248,76.322v47.136Z",
    transform: "translate(119.809 6.563)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpByg);
export default __webpack_public_path__ + "static/media/hp-byg.d3b36ddc.svg";
export { ForwardRef as ReactComponent };